<script lang="ts">
    import Rating from '../Rating.svelte'
    import Content from '../Content.svelte'
    import Footer from '../Footer.svelte'
    import { createEventDispatcher, SvelteComponent } from 'svelte'

    interface DataInterface {
        word: string
        rating: string
    }

    export let uuid: string
    export let words: string[]
    export let listNumber: number
    export let practice = false

    const dispatch = createEventDispatcher();

    let currentWordIndex = 0

    const submit = async (e) => {
        e.preventDefault()
        if (!practice) {
            for (const target of e.target) {
                if (target.checked) {
                    fetch('backend.php', {
                        method: "POST",
                        body: JSON.stringify({
                            data: {
                                word: words[currentWordIndex],
                                rating: target.value,
                                practice,
                            },
                            metadata: {listNumber},
                            url: document.location.href,
                            session: uuid
                        })
                    })
                }
            }
        }
        e.target.reset()
        if (currentWordIndex < words.length - 1) {
            currentWordIndex++
        } else {
            dispatch('done')
        }
    }
</script>

<Content>
    <div>
        <progress id="progress" value={currentWordIndex} max={words.length}> {currentWordIndex / words.length}% </progress>
        <label for="progress">{Math.floor(currentWordIndex * 100/words.length)}%</label>
    </div>
    <slot word={words[currentWordIndex]} />
    <Rating on:submit={submit} />
</Content>
<Footer>
    <div style="flex:1;"></div>
    <button type="submit" form="page-form">Suivant →</button>
</Footer>

<style>
    label {
        text-align: right;
    }
    #progress {
        width: 100%;
    }
</style>